<template>
    <div class="Banner" :class="[variant, isSlim ? 'isSlim' : '']">
        <Icon v-if="icon" :name="icon"/>
        <div class="body">
            <strong v-if="title">{{ title }}</strong>
            <div class="description">
                <slot></slot>
            </div>
        </div>
    </div>
</template>


<script>

export default {
    name: 'Banner',

    props: {
        title: { type: String, default: '' },
        icon: { type: String },
        variant: { type: String, default: 'info', validator: value => ['info', 'warning', 'danger', 'success'].includes(value) },
        isSlim: { type: Boolean, default: false },
    },
};
</script>


<style lang="scss" scoped>
@import 'globals.scss';

.Banner {
    display: flex;
    padding: 20px;
    gap: $grid-gutter-width;
    border-radius: $border-radius;
    background-color: rgba($blue-color, 0.15);
    font-size: 14px;
    text-align: left;

    strong {
        margin-bottom: 5px;
    }

    .Icon {
        font-size: 24px;
    }

    &.isSlim {
        padding: 10px;

        &.isSlim .Icon {
            font-size: 18px;
        }
    }

    &.info {
        background-color: rgba($blue-color, 0.15);
        .Icon {
            color: darken($blue-color, 10%);
        }
    }
    &.warning {
        background-color: rgba($yellow-color, 0.15);
        .Icon {
            color: darken($yellow-color, 10%);
        }
    }
    &.danger {
        background-color: rgba($red-color, 0.15);
        .Icon {
            color: darken($red-color, 10%);
        }
    }
    &.success {
        background-color: rgba($green-color, 0.15);
        .Icon {
            color: darken($green-color, 10%);
        }
    }
}
</style>
